<h2 mat-dialog-title>{{ getDisplayName() }}</h2>
<mat-dialog-content>
  @if (isImage()) {
    <a [href]="contentUrl" [tabIndex]="-1" target="_blank">
      <img class="dialog mat-elevation-z8" [alt]="vfile?.description" [src]="contentUrl">
    </a>
  }
  @if (isAudio()) {
    <audio controls [src]="contentUrl" autoplay></audio>
  }
  @if (isVideo()) {
    <video class="dialog mat-elevation-z8" controls [src]="contentUrl" autoplay></video>
  }
  @if (isPdf()) {
    <object class="dialog" [data]="contentUrl"></object>
  }
  @if (openLink) {
    <div class="margin-top-15">
      <a [href]="contentUrl" [tabIndex]="-1" target="_blank" class="icon-link">
        Open file in new window
        <mat-icon [inline]="true">open_in_new</mat-icon>
      </a>
    </div>
  }
  @if (downloadLinkName) {
    <div class="margin-top-15">
      <a [href]="contentUrl" [download]="getDisplayName()" [tabIndex]="-1" class="icon-link">
        {{ downloadLinkName }}
        <mat-icon [inline]="true">download</mat-icon>
      </a>
    </div>
  }

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onConfirm()" color="primary">Close</button>
</mat-dialog-actions>
